export default "__VITE_ASSET__Dzp7U_WR__"